// extracted by mini-css-extract-plugin
export var acitonButtons = "_ek-0";
export var additionalIcon = "_ek-f";
export var block = "_ek-1";
export var blockContent = "_ek-7";
export var blockDescription = "_ek-8";
export var blockIcon = "_ek-9";
export var blockTitle = "_ek-6";
export var border = "_ek-a";
export var center = "_ek-l";
export var edge = "_ek-b";
export var edgeLabel = "_ek-c";
export var edgePath = "_ek-d";
export var error = "_ek-e";
export var flowchart = "_ek-g";
export var flowchartContent = "_ek-h";
export var highlighted = "_ek-3";
export var hover = "_ek-4";
export var icon = "_ek-i";
export var left = "_ek-m";
export var navButton = "_ek-j";
export var navButtons = "_ek-k";
export var right = "_ek-n";
export var selected = "_ek-2";
export var small = "_ek-5";